import { render } from "./UploadFileForm.vue?vue&type=template&id=37f3e711"
import script from "./UploadFileForm.vue?vue&type=script&lang=js"
export * from "./UploadFileForm.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "37f3e711"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37f3e711', script)) {
    api.reload('37f3e711', script)
  }
  
  module.hot.accept("./UploadFileForm.vue?vue&type=template&id=37f3e711", () => {
    api.rerender('37f3e711', render)
  })

}

script.__file = "src/components/forms/UploadFileForm.vue"

export default script